import React from 'react';

class EmotionalIQDefinitions extends React.Component {
  render() {
    return (
      <div className="d-flex justify-content-center align-items-center w-100">
        <div className="col-12 col-md-8 col-lg-6 p-4 mx-auto">
          <h3 className="text-center mb-4">Emotional IQ Components Assessment</h3>
          <h5 className="text-center mb-4">Definitions Page</h5>
          <h5 className="mt-10">1. Self-Awareness</h5>
          <ul>
            <li><b>Emotional Awareness:</b> Recognizing your own emotions and their effects.</li>
            <li><b>Accurate Self-Assessment:</b> Knowing your strengths and limitations.</li>
            <li><b>Self-Confidence:</b> Having a strong sense of your self-worth and capabilities.</li>
          </ul>

          <h5>2. Self-Regulation</h5>
          <ul>
            <li><b>Self-Control:</b> Managing disruptive emotions and impulses.</li>
            <li><b>Trustworthiness:</b> Maintaining standards of honesty and integrity.</li>
            <li><b>Conscientiousness:</b> Taking responsibility for personal performance.</li>
            <li><b>Adaptability:</b> Flexibility in adapting to changing situations or overcoming obstacles.</li>
            <li><b>Innovation:</b> Being open to new ideas and approaches.</li>
          </ul>

          <h5>3. Motivation</h5>
          <ul>
            <li><b>Achievement Drive:</b> Striving to improve or meet a standard of excellence.</li>
            <li><b>Commitment:</b> Aligning with the goals of the group or organization.</li>
            <li><b>Initiative:</b> Readiness to act on opportunities.</li>
            <li><b>Optimism:</b> Persistence in pursuing goals despite obstacles and setbacks.</li>
          </ul>

          <h5>4. Empathy</h5>
          <ul>
            <li><b>Understanding Others:</b> Sensing others' feelings and perspectives, and taking an active interest in their concerns.</li>
            <li><b>Developing Others:</b> Sensing others' development needs and bolstering their abilities.</li>
            <li><b>Service Orientation:</b> Anticipating, recognizing, and meeting customers' needs.</li>
          </ul>

          <h5>5. Social Skills</h5>
          <ul>
            <li><b>Influence:</b> Wielding effective tactics for persuasion.</li>
            <li><b>Communication:</b> Listening openly and sending convincing messages.</li>
            <li><b>Conflict Management:</b> Negotiating and resolving disagreements.</li>
            <li><b>Leadership:</b> Inspiring and guiding individuals and groups.</li>
            <li><b>Change Catalyst:</b> Initiating or managing change.</li>
            <li><b>Building Bonds:</b> Nurturing instrumental relationships.</li>
            <li><b>Collaboration and Cooperation:</b> Working with others toward shared goals.</li>
            <li><b>Team Capabilities:</b> Creating group synergy in pursuing collective goals.</li>
          </ul>

          <div className="d-flex justify-content-center w-100 mt-4">
            <button
              type="button"
              className="btn btn-primary mt-4"
              onClick={this.props.onNext}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default EmotionalIQDefinitions;
